var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button-base',_vm._b({staticClass:"secondary",on:{"click":function($event){return _vm.handleClick($event)}}},'button-base',[_vm.$props, _vm.$attrs],false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }